<template>
    <div class="flex flex-col gap-7">
        <page-items-content
            :is-loading="navStore.isLoading"
            :page-items="pageItems"
        />
    </div>
</template>

<script setup lang="ts">
    import { nextTick, onMounted, ref, type Ref } from 'vue';
    import type { IPageItem, IRssPageItem } from '~/types/types';
    import PageItemsContent from '~/components/pageContent/PageItemsContent.vue';
    import { getRssPageData } from '~/utils/dataProviders/RssPageApiDataProvider';
    import { useAccountStore } from '~/stores/accountStore';
    import { useNavigationStore } from '~/stores/navigationStore';

    const props = defineProps({
        rssLink: {
            type: String,
            required: false,
            default: null,
        },
        orderBy: {
            type: String,
            required: false,
            default: null,
        },
    });

    const pageItems: Ref<IPageItem[]> = ref([]);
    const navStore = useNavigationStore();

    const setPageData = async () => {
        navStore.setLoading(true);
        const lastActiveItem = navStore.getLastActiveNavItem;
        const rssLink = props.rssLink || lastActiveItem?.rss;
        const orderBy = props.orderBy || lastActiveItem?.orderBy;

        if (!rssLink) {
            showError({ statusCode: 404, name: 'No RSS items' });
            navStore.setLoading(false);
            return;
        }

        const rssItems = await getRssPageData(useAccountStore().state.locale, rssLink, orderBy);
        pageItems.value = rssItems.map((rssItem: IRssPageItem) => {
            return {
                title: rssItem.title,
                description: rssItem.description,
                url: rssItem.link,
                image: rssItem.imageUrl,
                publishedAt: rssItem.publishedAt,
            };
        });

        navStore.setLoading(false);
    };

    onMounted( () => {
        nextTick(() => {
            setPageData();
        });
    });
</script>
